module.exports = __webpack_public_path__ + "img/施工技术方案智能审核平台.ba4bceae.jpg";